import React from 'react';
import { useStatesQuery } from '@uplift/queries';


export const StateLabel: React.VFC<{
  stateId: string;
}> = ({ stateId }) => {
  const { data: states } = useStatesQuery({ suspense: true });
  const state = states.find(s => s.id === stateId);

  if (!state) {
    return null;
  }

  return (
    <>
      {state.fullName}
    </>
  );
};


export const StatesLabel: React.VFC<{
  stateIds: string[];
}> = ({ stateIds }) => {
  const { data: states } = useStatesQuery({ suspense: true });
  const stateNames = stateIds.map((stateId) => states?.find((state) => state.id === stateId)?.fullName).filter(Boolean);

  return (
    <span>
      {stateNames.join(', ') || 'No states found'}
    </span>
  );
};
